import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Button, Grid } from '@mui/material';
import { reduxForm } from 'redux-form';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import TabPanel from '../../../../shared/components/TabPanel';
import { DEPLOYMENT_FORM_NAME } from '../../../../store/form/formStateModel';
import { DeploymentModel, ServerReloadStatus } from '../../../../models/deploymentModel';
import DeploymentInfoFields from './DeploymentInfoFields';
import DeploymentErrorFields from './DeploymentErrorFields';

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: 20,
    width: '100%',
    height: 'auto',
    flexGrow: 1,
  },
  button: {
    marginRight: "15px"
  },
  footer: {
    padding: '24px 16px',
    marginTop: "auto",
    backgroundColor: '#eeeeee',
  }
}));

export type DeploymentDataForm = DeploymentModel;

type Props = {
  readonly title: string;
  readonly deploymentId?: string;
  readonly failedServerReloads: ServerReloadStatus[];
  readonly initialValues?: Partial<DeploymentDataForm>;
  readonly onCancel: () => void;
  readonly readOnly: boolean;
}

const DeploymentInfoForm = (props: Props) => {
  const [tab, setTab] = useState<number>(0);

  const { onCancel, readOnly, failedServerReloads } = props;
  const classes = useStyles();

  const errorMessage = props.initialValues?.status?.errorMessage;
  const stackTrace = props.initialValues?.status?.stackTrace;

  return (
    <React.Fragment>
      <Grid container>
        <Grid item style={{ width: '100%' }}>
          <AppBar position='static'>
            <Typography variant="h6" style={{ padding: '10px 20px' }}>
              Deployment details
            </Typography>
          </AppBar>
        </Grid>
      </Grid>
      <Grid container>
      <Paper style={{ backgroundColor: '#F5F5F5', width: '100%' }}>
          <Tabs
            style={{ minHeight: '100%' }}
            value={tab}
            onChange={(event, value) => setTab(value)}
            indicatorColor='primary'
            textColor='primary'
            variant='scrollable'
          >
            <Tab label='Info' value={0} />
            {(errorMessage && stackTrace) && (
              <Tab label='Deployment error' value={1} />
            )}
            { failedServerReloads.length > 0 && (
              <Tab label='Server reloads error' value={2} />
            )}
          </Tabs>
        </Paper>
        <div className={classes.root} style={{ padding: '20px 25px 0' }}>
          <Grid item style={{ width: '100%' }}>
            <TabPanel value={tab} index={0}>
              <DeploymentInfoFields readOnly={readOnly} />
            </TabPanel>
            <TabPanel value={tab} index={1}>
              <DeploymentErrorFields errorMessage={errorMessage} stackTrace={stackTrace} />
            </TabPanel>
            <TabPanel value={tab} index={2}>
              { failedServerReloads.map((serverReload, idx) => (
                <div key={idx}>
                  <Typography>{serverReload.reloadMethod}</Typography>
                  <DeploymentErrorFields errorMessage={serverReload.errorMessage} />
                </div>
              ))}
            </TabPanel>
          </Grid>
        </div>
      </Grid>
      <footer className={classes.footer}>
        <Container>
          <Button
            color={"primary"}
            className={classes.button}
            onClick={onCancel}
          >Close</Button>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default reduxForm<DeploymentDataForm, Props>({
  form: DEPLOYMENT_FORM_NAME,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false,
})(DeploymentInfoForm);
